/**
 * IMPORTS
 */

import { useCallback, useEffect, useState } from "react";

import { File } from "lucide-react";

// components
import { Button } from "@components/button/button";
import { Spinner } from "@components/spinner/spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/tabs";

// components / pages
import { SearchRequestTable } from "@pages/client/search-requests/components/search-request-table/search-request-table";

// domain / use-cases
import { handleGetPegarTarefas } from "@/domain/use-cases/pick-up-task";

// typings
import { IDowloadLoadProps } from "./interface";

const ShippingSearchRequestPages = () => {
  const [dowloadLoad, setDowloadLoad] = useState<IDowloadLoadProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // Página atual
  const [itemsPerPage] = useState(5); // Itens por página
  const [_totalItems, setTotalItems] = useState(0); // Total de itens

  const handleGetAllDowloadLoad = useCallback(async () => {
    setIsLoading(true);

    try {
      const data = await handleGetPegarTarefas("Token", currentPage, itemsPerPage, "");

      setDowloadLoad(data);
      setTotalItems(data?.length ?? 0);

      return;
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, itemsPerPage]);

  const nextPaginate = useCallback(() => setCurrentPage((old) => old + 1), []);

  useEffect(() => {
    void handleGetAllDowloadLoad();
  }, [handleGetAllDowloadLoad]);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Tabs defaultValue="all">
            <div className="flex items-center">
              <TabsList className="">
                <TabsTrigger value="all" className="">
                  Remessas
                </TabsTrigger>
                <TabsTrigger value="active">Minhas Tarefas</TabsTrigger>
              </TabsList>
              <div className="ml-auto flex items-center gap-2">
                <Button size="sm" variant="default" className="h-8 gap-1 text-neutral-50">
                  <File className="h-3.5 w-3.5" />
                  <span className="sm:whitespace-nowra sr-only text-neutral-50 sm:not-sr-only">
                    Exportar
                  </span>
                </Button>
              </div>
            </div>
            <TabsContent value="all">
              <SearchRequestTable
                nextPaginate={nextPaginate}
                products={dowloadLoad}
                offset={itemsPerPage}
                totalProducts={10}
              />
            </TabsContent>
          </Tabs>
        </>
      )}
    </>
  );
};

/**
 * EXPORTS
 */
export { ShippingSearchRequestPages };
